import React from "react"
import styled from "styled-components"
import { AppFunctionComponent } from "../../types"

const InvisibleNavigation = styled.nav`
  opacity: 0;
  position: absolute;
  top: -50px;
`

export const contentStartId = "content-start"
export const linksMapId = "links-map"

const SkipLinksNavigation: AppFunctionComponent = () => {
  return (
    <InvisibleNavigation aria-label={"Skip links"}>
      <a href={`#${contentStartId}`}>Skip to content</a>
      <a href={`#${linksMapId}`}>Skip to site map</a>
    </InvisibleNavigation>
  )
}

export default SkipLinksNavigation
